module.exports = __webpack_public_path__ + "img/default-blue-picture.bdca993b.svg";